import React from "react";
import ReactApexChart from "react-apexcharts";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function WeeklyTrendChart({ weeks = [], height = 360 }) {
  const options = {
    chart: {
      type: "line",
      height,
      foreColor: "#8ba1c7",
      toolbar: {
        show: true,
        tools: {
          download: false,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
        },
        autoSelected: "zoom",
      },
      zoom: {
        enabled: true,
        type: "x",
        autoScaleYaxis: true,
      },
    },

    grid: {
      borderColor: "#233d5e",
      strokeDashArray: 3,
      padding: {
        top: 10,
        right: 20,
        bottom: 0,
        left: 10,
      },
    },

    xaxis: {
      categories: DAYS,
      labels: {
        style: {
          colors: "#8ba1c7",
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: true,
        color: "#d8e2ef",
      },
      axisTicks: {
        show: false,
      },
    },

    yaxis: {
      labels: {
        formatter: (v) => Number(v).toLocaleString(),
        style: {
          colors: "#8ba1c7",
          fontSize: "12px",
        },
      },

      title: {
        text: "Gallons", // Update title if units changed
        style: { color: "#8ba1c7" },
      },

      labels: {
        formatter: (v) => Number(v).toLocaleString(),
        style: {
          colors: "#8ba1c7",
          fontSize: "12px",
        },
      },
    },

    tooltip: {
      theme: "dark",
      y: {
        formatter: (v) => `${Number(v).toLocaleString()} kgal`,
      },
    },

    stroke: {
      width: 2.5,
      curve: "smooth",
    },

    markers: {
      size: 5,
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },

    dataLabels: {
      enabled: false,
    },

    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      labels: {
        colors: "#ffffff",
      },
      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 8,
      },
    },

    colors: ["#1998f0", "#42a5f5", "#66d6a3", "#ffb64d"],
  };

  const series = weeks.map((week) => ({
    name: week.name,
    data: week.data,
  }));

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="line"
      height={height}
    />
  );
}
